import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SignOutButton from './SignOut';
import * as routes from '../constants/routes';


import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';

//import logo from './img/logo_head.png'
//const logo = require('./img/logo_head.png');
const logo = process.env.PUBLIC_URL + 'logo_head.png';

const styleTitle = {
    'padding-left': '10px'
};

const NavigationNonAuth = (props, { authUser }) =>
 <div>
     <AppBar position="static" color="default">
        <Toolbar>
            <img src={logo} alt="SeCo.ai" />
          <Typography variant="title" color="inherit" style={styleTitle}>
            SeCo.ai
          </Typography>
        </Toolbar>
      </AppBar>
    <ul>
        <li><Link to={routes.LANDING}>Landing</Link></li>
        <li><Link to={routes.SIGN_IN}>Sign In</Link></li>
        <li>
        {(authUser && authUser.emailVerified) ?
            (<Typography>E-mail verified</Typography>) :
            (<Typography>E-mail not verified</Typography>)

        }
        </li>
        <li>
        { (authUser && authUser.tenant) ? 
            (<Typography>Tenant is {authUser.tenant}</Typography>) :
            (<Typography>No tenant set yet</Typography>)
        }
        </li>
        <li>
        { (authUser && authUser.role) ? 
            (<Typography>Role is {authUser.role}</Typography>) :
            (<Typography>No role set yet</Typography>)
        }
        </li>
    </ul>
  </div>

  NavigationNonAuth.contextTypes = {
    authUser: PropTypes.object,
  };

export default NavigationNonAuth;


// WEBPACK FOOTER //
// ./src/components/NavigationNonAuth.js